export const html =
  "<h1>We’ll be back soon!</h1><p>We’re busy updating our website at the moment. Check back later to see our improvements. In the meantime, you can still access all our online casino games. Just <a href='/quick-login'>log in</a> to your account or <a href='/onboarding/register'>sign up</a> to become a member.</a>"

export const heroProps = {
  image: '404',
  altText: 'alt text from props',
  showAppStoreImage: true,
  androidImage: '404',
  iosImage: '404',
  isDesktopClickable: true,
  globalContent: {
    appLinks: {
      android: 'https://play.google.com/',
      ios: 'https://www.apple.com/uk/app-store/'
    }
  }
}

const rgLogo = {
  showRGLogo: false,
  href: '/responsiblegaming',
  url: '/images/rg-logo.webp'
}

const monopolyCasinoTitle = 'MONOPOLY Casino'

export const headerProps = {
  jackpotjoy: {
    rgLogo,
    showSearchIcon: false,
    logo: {
      showLogo: true,
      url: '/logo.svg',
      to: '/',
      title: 'Jackpotjoy',
      dataTracking: {
        label: 'Menu Item',
        name: '/'
      },
      alt: 'Jackpotjoy'
    },
    buttons: {
      showButtons: true,
      button1: {
        href: null,
        title: 'Login',
        dataTracking: { label: 'Login' }
      },
      button2: {
        href: null,
        title: 'Join Now',
        dataTracking: { label: 'Join Now' }
      }
    }
  },
  monopolycasino: {
    rgLogo,
    showSearchIcon: false,
    logo: {
      showLogo: true,
      url: '/logo.svg',
      to: '/',
      title: monopolyCasinoTitle,
      dataTracking: {
        label: 'Menu Item',
        name: '/'
      },
      alt: monopolyCasinoTitle
    },
    buttons: {
      showButtons: true,
      button1: {
        href: null,
        title: 'Login',
        dataTracking: { label: 'Login' }
      },
      button2: {
        href: null,
        title: 'Join Now',
        dataTracking: { label: 'Join Now' }
      }
    }
  },
  monopolycasinous: {
    rgLogo,
    showSearchIcon: false,
    logo: {
      showLogo: true,
      url: '/logo.svg',
      to: '/',
      title: monopolyCasinoTitle,
      dataTracking: {
        label: 'Menu Item',
        name: '/'
      },
      alt: monopolyCasinoTitle
    },
    buttons: {
      showButtons: true,
      button1: {
        href: null,
        title: 'Login',
        dataTracking: { label: 'Login' }
      },
      button2: {
        href: null,
        title: 'Join Now',
        dataTracking: { label: 'Join Now' }
      }
    }
  },
  monopolycasinoca: {
    rgLogo,
    showSearchIcon: false,
    logo: {
      showLogo: true,
      url: '/logo.svg',
      to: '/',
      title: monopolyCasinoTitle,
      dataTracking: {
        label: 'Menu Item',
        name: '/'
      },
      alt: monopolyCasinoTitle
    },
    buttons: {
      showButtons: true,
      button1: {
        href: null,
        title: 'Login',
        dataTracking: { label: 'Login' }
      },
      button2: {
        href: null,
        title: 'Join Now',
        dataTracking: { label: 'Join Now' }
      }
    }
  },
  virgingames: {
    rgLogo,
    showSearchIcon: false,
    logo: {
      showLogo: true,
      url: '/logo.svg',
      to: '/',
      title: 'Virgin Games',
      dataTracking: {
        label: 'Menu Item',
        name: '/'
      },
      alt: 'Virgin Games'
    },
    buttons: {
      showButtons: true,
      button1: {
        href: null,
        title: 'Login',
        dataTracking: { label: 'Login' }
      },
      button2: {
        href: null,
        title: 'Join Now',
        dataTracking: { label: 'Join Now' }
      }
    }
  },
  rainbowrichescasino: {
    rgLogo,
    showSearchIcon: false,
    logo: {
      showLogo: true,
      url: '/logo.png',
      to: '/',
      title: 'Rainbow Riches Casino',
      dataTracking: {
        label: 'Menu Item',
        name: '/'
      },
      alt: 'Rainbow Riches Casino'
    },
    buttons: {
      showButtons: false,
      button1: {
        href: null,
        title: 'Login',
        dataTracking: { label: 'Login' }
      },
      button2: {
        href: null,
        title: 'Join Now',
        dataTracking: { label: 'Join Now' }
      }
    }
  },
  botemania_es: {
    rgLogo,
    showSearchIcon: false,
    logo: {
      showLogo: true,
      url: '/logo.svg',
      to: '/',
      title: 'Botemania',
      dataTracking: {
        label: 'Menu Item',
        name: '/'
      },
      alt: 'Botemania'
    },
    buttons: {
      showButtons: true,
      button1: {
        href: null,
        title: 'Entra',
        dataTracking: { label: 'Login' }
      },
      button2: {
        href: null,
        title: 'Regístrate',
        dataTracking: { label: 'Join Now' }
      }
    }
  },
  monopolycasino_es: {
    rgLogo,
    showSearchIcon: false,
    logo: {
      showLogo: true,
      url: '/logo.svg',
      to: '/',
      title: monopolyCasinoTitle,
      dataTracking: {
        label: 'Menu Item',
        name: '/'
      },
      alt: monopolyCasinoTitle
    },
    buttons: {
      showButtons: true,
      button1: {
        href: null,
        title: 'Entra',
        dataTracking: { label: 'Login' }
      },
      button2: {
        href: null,
        title: 'Regístrate',
        dataTracking: { label: 'Join Now' }
      }
    }
  },
  virgincasino: {
    showSearchIcon: false,
    rgLogo: {
      ...rgLogo,
      showRGLogo: true
    },
    logo: {
      showLogo: true,
      url: '/logo.svg',
      to: '/',
      title: 'Virgin Casino',
      dataTracking: {
        label: 'Menu Item',
        name: '/'
      },
      alt: 'Virgin Casino'
    },
    buttons: {
      showButtons: true,
      button1: {
        href: null,
        title: 'Login',
        dataTracking: { label: 'Login' }
      },
      button2: {
        href: null,
        title: 'Join Now',
        dataTracking: { label: 'Join Now' }
      }
    }
  },
  doublebubblebingo: {
    rgLogo,
    showSearchIcon: false,
    logo: {
      showLogo: true,
      url: '/logo.png',
      to: '/',
      title: 'Login',
      dataTracking: {
        label: 'Menu Item',
        name: '/'
      },
      alt: 'Double Bubble Bingo'
    },
    buttons: {
      showButtons: true,
      button1: {
        href: null,
        title: 'Login',
        dataTracking: { label: 'Login' }
      },
      button2: {
        href: null,
        title: 'Join Now',
        dataTracking: { label: 'Join Now' }
      }
    }
  },
  ballycasinonj: {
    showSearchIcon: false,
    rgLogo: {
      ...rgLogo,
      showRGLogo: true
    },
    logo: {
      showLogo: true,
      url: '/logo.svg',
      to: '/',
      title: 'Bally Casino',
      dataTracking: {
        label: 'Menu Item',
        name: '/'
      },
      alt: 'Bally Casino'
    },
    buttons: {
      showButtons: true,
      button1: {
        href: null,
        title: 'Login',
        dataTracking: { label: 'Login' }
      },
      button2: {
        href: null,
        title: 'Join Now',
        dataTracking: { label: 'Join Now' }
      }
    }
  },
  ballyuk: {
    rgLogo,
    showSearchIcon: false,
    logo: {
      showLogo: true,
      url: '/logo.svg',
      to: '/',
      title: 'Bally Casino',
      dataTracking: {
        label: 'Menu Item',
        name: '/'
      },
      alt: 'Bally Casino'
    },
    buttons: {
      showButtons: true,
      button1: {
        href: null,
        title: 'Login',
        dataTracking: { label: 'Login' }
      },
      button2: {
        href: null,
        title: 'Join Now',
        dataTracking: { label: 'Join Now' }
      }
    }
  },
  ballybetaz: {
    rgLogo,
    showSearchIcon: false,
    showNewHeader: true,
    logo: {
      showLogo: true,
      url: '/ballybet-logo.svg',
      mobileUrl: '/logo.png',
      to: '/',
      title: 'Bally Bet',
      dataTracking: {
        label: 'logo',
        name: '/'
      },
      alt: 'Bally Bet'
    },
    buttons: {
      showButtons: true,
      button1: {
        href: null,
        title: 'Download App'
      },
      button2: {}
    }
  },
  ballybetca: {
    showSearchIcon: false,
    rgLogo: {
      ...rgLogo,
      url: '/ca/images/rg-logo.webp'
    },
    logo: {
      showLogo: true,
      url: '/ca/logo.svg',
      to: '/',
      title: 'Bally Bet',
      dataTracking: {
        label: 'Menu Item',
        name: '/'
      },
      alt: 'Bally Bet',
      mobileUrl: '/ca/logo2.svg'
    },
    buttons: {
      showButtons: true,
      button1: {
        href: null,
        title: 'Login',
        dataTracking: { label: 'Login' }
      },
      button2: {
        href: null,
        title: 'Join Now',
        dataTracking: { label: 'Join Now' }
      }
    }
  }
}
